/**
 * apps/web :: pass :: screens/PreTripChecklist
 *
 * Phase-1 checklist — what to sort before you leave home (ROADS-569 W1.C4).
 * Thin wrapper over ChecklistScreen with phase="pre".
 */
import ChecklistScreen from "./ChecklistScreen";

export default function PreTripChecklist(): JSX.Element {
  return (
    <ChecklistScreen
      phase="pre"
      eyebrow="Phase 1 · Before you leave home"
      title="Pre-trip checklist"
      accent="text-emerald-600"
    />
  );
}
